// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__32hJX","head":"ProcedureTableInfo_head__EWqJ_"};